import DownloadModel from '../modules/DownloadModel';

/**
 * MSE初始化类
 *
 */
class MSE {
    /**
     * Creates an instance of MSE.
     * @param {any} {video, }
     */
    constructor({ video, mp4Url, segmentSize, showTestInfo }) {
        /**
         * mse
         */
        this.mediaSource = null;
        this.video = video;
        this.autoplay = true;
        this.downloadObj = new DownloadModel({ showTestInfo });
        this.mp4box = new MP4Box();
        this.movieInfo = null;
        this.mp4Url = mp4Url;
        this.segmentSize = segmentSize;
        this.bitrate = null;
    }

    init() {
        this.reset();
    }

    reset() {
        // this.stop();
        this.resetMediaSource();
    }

    start() {
        this.mp4box.start();
    }

    /**
     * 播放
     */
    play() {
        this.autoplay = true;
        console.log('play');
        // this.video.play();
    }

    pause() {
        this.downloadObj.pause();
    }

    /**
     * 开始加载
     */
    load() {
        // debugger
        console.log('load');
        let ms = this.video.ms;

        if (ms.readyState !== 'open') {
            setTimeout(this.load.bind(this), 300);
            return;
        }

        this.downloadObjInit();

        this.mp4box.onMoovStart = function() {
            //console.info('Application', 'Starting to parse movie information');
        };
        this.mp4box.onReady = info => {
            // console.info('Application', 'Movie information received');
            //console.log(info)
            this.bitrate = info.duration;
            this.movieInfo = info;
            if (info.isFragmented) {
                ms.duration = info.fragment_duration / info.timescale;
            } else {
                ms.duration = info.duration / info.timescale;
            }

            if (this.autoplay) {
                this.initializeAllSourceBuffers();
            }
        };

        this.mp4box.onSegment = (id, user, buffer, sampleNum) => {
            let sb = user;
            // saveBuffer(buffer, 'track-' + id + '-segment-' + sb.segmentIndex + '.m4s');
            sb.segmentIndex++;
            sb.pendingAppends.push({
                id: id,
                buffer: buffer,
                sampleNum: sampleNum,
            });
            console.info(
                'Application',
                'Received new segment for track ' +
                    id +
                    ' up to sample #' +
                    sampleNum +
                    ', segments pending append: ' +
                    sb.pendingAppends.length +
                    '---' +
                    sb.segmentIndex,
            );
            this.onUpdateEnd.call(sb, this.mp4box, this.video, true, false);
        };

        this.mp4box.onerror = e => {
            console.log(e);
        };
    }

    getRate() {
        return this.bitrate;
    }

    initializeAllSourceBuffers() {
        if (this.movieInfo) {
            let info = this.movieInfo;
            for (let i = 0; i < info.tracks.length; i++) {
                let track = info.tracks[i];
                this.addBuffer(this.video, track);
                // let checkBox = document.getElementById("addTrack" + track.id);
                // checkBox.checked = true;
            }
            this.initializeSourceBuffers();
        }
    }

    // 切换视频源
    changeRate() {
        this.video.ms = this.mediaSource;
        this.mediaSource.addEventListener('sourceopen', this.onSourceOpen.bind(this));
        this.mediaSource.addEventListener('sourceclose', this.onSourceClose.bind(this));
        this.downloadObj.pause();
        this.setVideoSrc();
    }

    /**
     * 重置MSE
     */
    resetMediaSource() {
        this.mediaSource = null;
        this.mediaSource = new MediaSource();
        this.video.ms = this.mediaSource;
        this.mediaSource.addEventListener('sourceopen', this.onSourceOpen.bind(this));
        this.mediaSource.addEventListener('sourceclose', this.onSourceClose.bind(this));
        this.downloadObj.pause();
        this.setVideoSrc();
    }

    setVideoSrc() {
        this.video.src = window.URL.createObjectURL(this.mediaSource);
    }

    addBuffer(video, mp4track) {
        let sb;
        let ms = video.ms;
        let mp4box = this.mp4box;
        let track_id = mp4track.id;
        let codec = mp4track.codec;
        let mime = 'video/mp4; codecs="' + codec + '"';
        let kind = mp4track.kind;
        let trackDefault;
        let trackDefaultSupport = typeof TrackDefault !== 'undefined';
        let html5TrackKind = '';
        if (codec == 'wvtt') {
            if (!kind.schemeURI.startsWith('urn:gpac:')) {
                html5TrackKind = 'subtitles';
            } else {
                html5TrackKind = 'metadata';
            }
        } else {
            if (kind && kind.schemeURI === 'urn:w3c:html5:kind') {
                html5TrackKind = kind.value || '';
            }
        }
        if (trackDefaultSupport) {
            // mp4track.type = 'video';
            if (mp4track.type === 'video' || mp4track.type === 'audio') {
                trackDefault = new TrackDefault(
                    mp4track.type,
                    mp4track.language,
                    mp4track.name,
                    [html5TrackKind],
                    track_id,
                );
            } else {
                trackDefault = new TrackDefault('text', mp4track.language, mp4track.name, [html5TrackKind], track_id);
            }
        }
        if (MediaSource.isTypeSupported(mime)) {
            try {
                console.info('MSE - SourceBuffer #' + track_id, "Creation with type '" + mime + "'");
                sb = ms.addSourceBuffer(mime); // 创建mediasource
                if (trackDefaultSupport) {
                    sb.trackDefaults = new TrackDefaultList([trackDefault]);
                }
                sb.addEventListener('error', function(e) {
                    console.error('MSE SourceBuffer #' + track_id, e);
                });
                sb.ms = ms;
                sb.id = track_id;
                mp4box.setSegmentOptions(track_id, sb, {
                    nbSamples: parseInt(this.segmentSize),
                });
                sb.pendingAppends = [];
                console.log(`sb.buffered===========>`, sb.buffered);
            } catch (e) {
                console.error('MSE - SourceBuffer #' + track_id, "Cannot create buffer with type '" + mime + "'" + e);
            }
        }
    }

    initializeSourceBuffers() {
        let initSegs = this.mp4box.initializeSegmentation();
        for (let i = 0; i < initSegs.length; i++) {
            let sb = initSegs[i].user;
            if (i === 0) {
                sb.ms.pendingInits = 0;
            }
            sb.addEventListener('updateend', this.onInitAppended.bind(this));
            console.info('MSE - SourceBuffer #' + sb.id, 'Appending initialization data');
            sb.appendBuffer(initSegs[i].buffer);
            // saveBuffer(initSegs[i].buffer, 'track-' + initSegs[i].id + '-init.mp4');
            sb.segmentIndex = 0;
            sb.ms.pendingInits++;
        }
    }

    onInitAppended(e) {
        console.log('updateedn================')
        let sb = e.target;
        if (sb.ms.readyState === 'open') {
            MSE.updateBufferedString(sb, 'Init segment append ended', this.video.currentTime);
            sb.sampleNum = 0;
            sb.removeEventListener('updateend', this.onInitAppended.bind(this));
            sb.addEventListener('updateend', this.onUpdateEnd.bind(sb, this.mp4box, this.video, true, true));
            /* In case there are already pending buffers we call onUpdateEnd to start appending them*/
            this.onUpdateEnd.call(sb, this.mp4box, this.video, false, true);
            sb.ms.pendingInits--;
            if (this.autoplay && sb.ms.pendingInits === 0) {
                this.start();
            }
        }
    }

    onUpdateEnd(mp4box, video, isNotInit, isEndOfAppend) {
        if (isEndOfAppend === true) {
            if (isNotInit === true) {
                MSE.updateBufferedString(this, 'Update ended', video.currentTime);
            }
            if (this.sampleNum) {
                mp4box.releaseUsedSamples(this.id, this.sampleNum);
                delete this.sampleNum;
            }
        }
        if (this.ms.readyState === 'open' && this.updating === false && this.pendingAppends.length > 0) {
            let obj = this.pendingAppends.shift();
            console.info(
                'MSE - SourceBuffer #' + this.id,
                'Appending new buffer, pending: ' + this.pendingAppends.length,
                this,
            );
            this.sampleNum = obj.sampleNum;
            this.appendBuffer(obj.buffer);
        }
    }

    /**
     *
     */
    downloadObjInit() {
        this.downloadObj.init({
            mURL: this.mp4Url,
            mReturnDataCallback: this.downloadDataCallback.bind(this),
        });
    }

    downloadDataCallback(buffer, start) {
        if (buffer) {
            console.log(`start====================================> ${start}`, buffer.buffer);
            buffer.buffer.fileStart = start;
            this.mp4box.appendBuffer(buffer.buffer);
            this.mp4box.start();
            // this.video.play();
        }
    }

    onSourceClose(e) {
        let ms = e.target;
        if (this.video.error) {
            console.error('MSE', 'Source closed, video error: ' + this.video.error.code);
        } else {
            console.info('MSE', 'Source closed, no error');
        }
    }

    onSourceOpen(e) {
        let ms = e.target;
        console.info('MSE', 'Source opened');
        // console.debug('MSE', ms);
    }

    static updateBufferedString(sb, string, currentTime) {
        let rangeString;
        if (sb.ms.readyState === 'open') {
            rangeString = MSE.printRanges(sb.buffered);
            //console.info("MSE - SourceBuffer #" + sb.id, string + ", updating: " + sb.updating + ", currentTime: " + MSE.getDurationString(currentTime, 1) + ", buffered: " + rangeString + ", pending: " + sb.pendingAppends.length);
        }
    }

    static printRanges(ranges) {
        let length = ranges.length;
        if (length > 0) {
            let str = '';
            for (let i = 0; i < length; i++) {
                if (i > 0) str += ',';
                str += '[' + MSE.getDurationString(ranges.start(i)) + ',' + MSE.getDurationString(ranges.end(i)) + ']';
            }
            return str;
        } else {
            return '(empty)';
        }
    }

    /* Helper function to print a duration value in the form H:MM:SS.MS */
    static getDurationString(duration, _timescale) {
        let neg;
        /* Helper function to print a number on a fixed number of digits */
        function pad(number, length) {
            let str = '' + number;
            let a = str.split('.');
            while (a[0].length < length) {
                a[0] = '0' + a[0];
            }
            return a.join('.');
        }
        if (duration < 0) {
            neg = true;
            duration = -duration;
        } else {
            neg = false;
        }
        let timescale = _timescale || 1;
        let duration_sec = duration / timescale;
        let hours = Math.floor(duration_sec / 3600);
        duration_sec -= hours * 3600;
        let minutes = Math.floor(duration_sec / 60);
        duration_sec -= minutes * 60;
        let msec = duration_sec * 1000;
        duration_sec = Math.floor(duration_sec);
        msec -= duration_sec * 1000;
        msec = Math.floor(msec);
        return (neg ? '-' : '') + hours + ':' + pad(minutes, 2) + ':' + pad(duration_sec, 2) + '.' + pad(msec, 3);
    }
}

export default MSE;



// WEBPACK FOOTER //
// ./components/f.component.mediasource/app/lib/mediaSource.js